/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FlagExcludeIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Flag Exclude',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18.667 17.972A12.259 12.259 0 0 1 34 16.893V7.648a1 1 0 0 0-.751-.98 19.491 19.491 0 0 0-4.666-.568 18.988 18.988 0 0 0-4.112.454 1.093 1.093 0 0 1-1.3-1.085v-1.61a1.087 1.087 0 0 0-.814-1.06 19.5 19.5 0 0 0-4.6-.548 19.432 19.432 0 0 0-9.75 3v15.161a19.374 19.374 0 0 1 9.759-2.995 1.061 1.061 0 0 1 .901.555Z"
    />
    <rect height="32" rx="1" ry="1" width="4" x="2" y="2" />
    <path
      d="M27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9ZM20 27a6.934 6.934 0 0 1 1.475-4.252l9.777 9.777A6.966 6.966 0 0 1 20 27Zm12.525 4.252-9.777-9.777a6.966 6.966 0 0 1 9.777 9.777Z"
    />
  </svg>`;
};
